'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useAppStore } from '@/store/app';

/** 研究页内「现货 / 合约 / 事件 / 历史验证 / 工作台 / 流动性 / AI 摘要」切换（R01 / F01 / E01 / H01 / W01 / L01 / AI 摘要）。 */
export default function ResearchTabs() {
  const { language } = useAppStore();
  const zh = language !== 'en';
  const pathname = usePathname();
  const isDeriv = pathname?.startsWith('/research/derivatives');
  const isEvents = pathname?.startsWith('/research/events');
  const isStudies = pathname?.startsWith('/research/studies');
  const isWorkspace = pathname?.startsWith('/workspace');
  const isLiquidity = pathname?.startsWith('/research/liquidity');
  const isSummary = pathname?.startsWith('/research/summary');

  const base =
    'flex flex-1 items-center justify-center rounded-md px-1 py-1.5 text-[11px] font-medium transition-colors sm:px-2 sm:text-sm';
  return (
    <div className="mb-4 flex w-full max-w-[780px] overflow-x-auto rounded-lg border border-gf-border bg-gf-surface2 p-0.5">
      <Link href="/research/spot" className={`${base} ${!isDeriv && !isEvents && !isStudies && !isWorkspace && !isLiquidity && !isSummary ? 'bg-gf-accent text-white' : 'text-gf-muted hover:text-gf-text'}`}>
        {zh ? '现货' : 'Spot'}
      </Link>
      <Link href="/research/derivatives" className={`${base} ${isDeriv ? 'bg-gf-accent text-white' : 'text-gf-muted hover:text-gf-text'}`}>
        {zh ? '合约' : 'Derivatives'}
      </Link>
      <Link href="/research/events" className={`${base} ${isEvents ? 'bg-gf-accent text-white' : 'text-gf-muted hover:text-gf-text'}`}>
        {zh ? '事件' : 'Events'}
      </Link>
      <Link href="/research/studies" className={`${base} ${isStudies ? 'bg-gf-accent text-white' : 'text-gf-muted hover:text-gf-text'}`}>
        {zh ? '历史验证' : 'History'}
      </Link>
      <Link href="/workspace" className={`${base} ${isWorkspace ? 'bg-gf-accent text-white' : 'text-gf-muted hover:text-gf-text'}`}>
        {zh ? '工作台' : 'Workspace'}
      </Link>
      <Link href="/research/liquidity" className={`${base} ${isLiquidity ? 'bg-gf-accent text-white' : 'text-gf-muted hover:text-gf-text'}`}>
        {zh ? '流动性／基差' : 'Liquidity'}
      </Link>
      <Link href="/research/summary" className={`${base} ${isSummary ? 'bg-gf-accent text-white' : 'text-gf-muted hover:text-gf-text'}`}>
        {zh ? 'AI 摘要' : 'AI Summary'}
      </Link>
    </div>
  );
}
